import { render, staticRenderFns } from "./UserCar.vue?vue&type=template&id=1280c94b&"
import script from "./UserCar.vue?vue&type=script&lang=js&"
export * from "./UserCar.vue?vue&type=script&lang=js&"
import style0 from "./UserCar.vue?vue&type=style&index=0&id=1280c94b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports